<script setup lang="ts">
import { useMediaUrl } from "@/composables"
import { calculateStyleString } from "../../CmsPage/configuration"
import { getHref, getTarget } from "./link-service"

const props = defineProps<{
    element: any
}>()

const { mediaUrl } = useMediaUrl()
</script>

<template>
    <div class="image-group">
        <template v-for="child in props.element?.columns[0]">
            <a
                class="image-group-link"
                :style="
                    calculateStyleString(child) +
                    ';' +
                    (child.fileName ? 'background-image: url(' + mediaUrl(child.fileName) + ')' : '')
                "
                :href="getHref(child)"
                :target="getTarget(child)"
            >
                {{ child.title }}
            </a>
        </template>
    </div>
</template>
